var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreferences = function SvgPreferences(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.832 4a2 2 0 1 0 4 0 2 2 0 0 0-4 0M6.832 20a2 2 0 1 0 4 0 2 2 0 0 0-4 0M11.332 4.25h11M11.332 20.25h11M2.332 4.25h4M2.332 20.25h4M13.832 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0M13.332 12.25h-11M22.332 12.25h-4"
  })));
};
export default SvgPreferences;